import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import TicketTable from 'Components/Tables/Ticket/TicketTable'

class MyTicketContainer extends React.Component {
  constructor (props) {
    super(props)
    this.contentSections = ['Assigned', 'Created']

    this.state = {
      currentContentSectionTab: (props.employee && props.assigneeUser) ? 'Assigned' : 'Created'
    }
  }

  showContentSection (event, correspondenceForm) {
    event.preventDefault()
    this.setState({ currentContentSectionTab: correspondenceForm })
  }

  currentContentSectionTabClass (type) {
    const { currentContentSectionTab } = this.state

    if (currentContentSectionTab === type) {
      return 'content-section__header-tab--active'
    }

    return ''
  }

  render () {
    const {
      assigneeUser,
      employee,
      assignedEndpoint,
      createdEndpoint,
      paths,
      ticketFilters,
      descendantTicketStatuses
    } = this.props
    const { currentContentSectionTab } = this.state
    const contentSectionHeaderTabs = _.map(this.contentSections, sectionName => (
      <div key={sectionName} className={`content-section__header-tab ${this.currentContentSectionTabClass(sectionName)}`} onClick={event => (this.showContentSection(event, sectionName))}>
        {sectionName}
      </div>
    ))

    return (
      <section className="content-section">
        { assigneeUser &&
          (
            <div className="content-section__header-tabs-container content-section__title--no-margin">
              {contentSectionHeaderTabs}
            </div>
          )
        }
        { assigneeUser && (
          <div style={currentContentSectionTab === 'Assigned' ? { padding: '30px' } : { display: 'none' }}>
            <TicketTable
              {...this.props}
              key="Assigned"
              employee={employee}
              paths={paths}
              ticketFilters={ticketFilters}
              onlyUserAssignedTickets
              endpoint={assignedEndpoint}
              localStoragePrefix="TicketTable-Assigned"
              descendantTicketStatuses={descendantTicketStatuses}
            />
          </div>
        )}

        <div style={currentContentSectionTab === 'Created' ? { padding: '30px' } : { display: 'none' }}>
          <TicketTable
            {...this.props}
            key="Created"
            employee={employee}
            paths={paths}
            ticketFilters={ticketFilters}
            onlyUserCreatedTickets
            endpoint={createdEndpoint}
            localStoragePrefix="TicketTable-Created"
            descendantTicketStatuses={descendantTicketStatuses}
          />
        </div>
      </section>
    )
  }
}

MyTicketContainer.propTypes = {
  endPoint: PropTypes.string.isRequired,
  assigneeUser: PropTypes.bool.isRequired,
  employee: PropTypes.bool.isRequired
}

export default MyTicketContainer
